// Kept apart from ./saveRelationships so reading these does not pull in the dispatch builder.

/** Base key for "no relationship recorded between these two people". */
export const NO_RELATION_KEY = 'NO_RELATION'

/** Selecting this stores nothing and clears any existing relationship. */
export const NO_RELATION_TYPE = `${NO_RELATION_KEY}_FIRST`
